var map = {
	"./AIRobot.js": "J89x",
	"./appointment.js": "YyxU",
	"./claim.js": "gUku",
	"./home.js": "roEk",
	"./instantAssistance.js": "J6Ho",
	"./insurance.js": "Ks20",
	"./issuecontrol.js": "3Qb5",
	"./jobnum.js": "DIwZ",
	"./marketing.js": "/r2I",
	"./organization.js": "iPao",
	"./policy.js": "ygVm",
	"./quote.js": "cOCY",
	"./report.js": "QJlH",
	"./role.js": "THZS",
	"./scheme.js": "37WQ",
	"./servicePackage.js": "fQwv"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "myVr";


//////////////////
// WEBPACK FOOTER
// ./src/router nonrecursive ^(?!\.\/index|\.\/cockpit).*\.js$
// module id = myVr
// module chunks = 226